import React, { useEffect } from 'react';
import redirectToLogin from 'utils/redirectToLogin';

export default function Redirect() {
  useEffect(() => {
    redirectToLogin();
  }, []);
  return <></>;
}
